import './benefits.scss'
import jnpl from './images/jnpl.png'
import korane from './images/korane.png'
import nadine from './images/nadine.png'
import leeve from './images/leeve.png'
import jrang from './images/jrang.png'
import cli from './images/cli.png'

function Benefits() {
    return (
        <div className='content benefits'>
            <div className='info'>
                <h2 className='info__header'>
                    We serve over 100
                    Nigerian Websites
                </h2>
                <div className='info__description'>
                    Connect LemonWares with your favourite tools that you use daily and keep things on track.
                </div>
            </div>
            <div className='products'>
                <div className='row'>
                    <img src={jnpl} alt='jnpl' className='solutions'/>
                    <img src={korane} alt='korane' className='solutions'/>
                    <img src={nadine} alt='nadine' className='solutions'/>
                </div>
                <div className='row'>
                    <img src={leeve} alt='leeve' className='solutions'/>
                    <img src={jrang} alt='jrang' className='solutions'/>
                    <img src={cli} alt='cli' className='solutions'/>
                </div>
            </div>
        </div>
    )
}

export default Benefits
